export const KEYFRAME_ANIMATION = {
  DEFAULT:
    '@keyframes bg-color {0% { background-color: #e0f1ed; } 100% { background-color: transparent; }}',
};
